export const PermissionEditType = {
  role: 1,
  user: 2
};
